import { useState, useEffect } from 'react';

import {
  ContentCopy,
  Check,
  Close,
} from '@mui/icons-material/'

export function ShareModal({ isModalOpen, setIsModalOpen }) {
  const [currentUrl, setCurrentUrl] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, [isModalOpen]);

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(currentUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      handleCopySuccess();
    } catch (err) {
      // Fallback para navegadores o entornos con restricciones de portapapeles
      const textArea = document.createElement("textarea");
      textArea.value = currentUrl;
      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        handleCopySuccess();
      } catch (e) {
        console.error("No se pudo copiar", e);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleCopySuccess = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>

            {/* Cabecera */}
            <div className="modal-header">
              <h3>Compartir</h3>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>
                <Close fontSize='20' />
              </button>
            </div>

            {/* Cuerpo */}
            <div className="modal-body">
              <span className="section-label">Enviar vía</span>

              <div className="social-grid">
                <a href={shareLinks.whatsapp} target="_blank" rel="noreferrer" className="social-item whatsapp">
                  <div className="icon-box">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                      <g id="Grupo_731" data-name="Grupo 731" transform="translate(-2389 -6638)">
                        <rect id="Rectángulo_468" data-name="Rectángulo 468" width="60" height="60" transform="translate(2389 6638)" fill="#25d366" />
                        <path id="Trazado_219" data-name="Trazado 219" d="M39.775,19.351A14.149,14.149,0,0,0,29.558,15,14.678,14.678,0,0,0,15.116,29.872,15.076,15.076,0,0,0,17.047,37.3L15,45l7.659-2.074a14.051,14.051,0,0,0,6.9,1.8A14.678,14.678,0,0,0,44,29.855,15,15,0,0,0,39.775,19.351ZM29.558,42.229a11.691,11.691,0,0,1-6.107-1.717l-.446-.272-4.539,1.224,1.2-4.555-.281-.476a12.6,12.6,0,0,1-1.832-6.578A12.207,12.207,0,0,1,29.574,17.5a11.765,11.765,0,0,1,8.484,3.62,12.481,12.481,0,0,1,3.516,8.736A12.222,12.222,0,0,1,29.558,42.229Zm6.586-9.264c-.363-.187-2.129-1.088-2.459-1.207s-.578-.187-.809.187c-.248.374-.924,1.207-1.139,1.462s-.413.272-.776.085a9.977,9.977,0,0,1-2.9-1.836,11.732,11.732,0,0,1-2.014-2.566c-.215-.374-.017-.578.165-.765.165-.17.363-.442.545-.646a2.593,2.593,0,0,0,.363-.612.679.679,0,0,0-.033-.646c-.083-.187-.809-2.023-1.106-2.753s-.594-.629-.809-.646-.446-.017-.693-.017a1.271,1.271,0,0,0-.957.459,4.227,4.227,0,0,0-1.271,3.094A7.326,7.326,0,0,0,23.715,30.4c.182.255,2.542,3.994,6.157,5.609a17.825,17.825,0,0,0,2.063.782,4.892,4.892,0,0,0,2.278.153,3.752,3.752,0,0,0,2.443-1.768,3.334,3.334,0,0,0,.215-1.768A2.342,2.342,0,0,0,36.143,32.966Z" transform="translate(2389 6638)" fill="#fff" />
                      </g>
                    </svg>

                  </div>
                  <span>WhatsApp</span>
                </a>

                <a href={shareLinks.twitter} target="_blank" rel="noreferrer" className="social-item twitter">
                  <div className="icon-box">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                      <g id="Grupo_735" data-name="Grupo 735" transform="translate(-2080 -6812)">
                        <g id="Grupo_733" data-name="Grupo 733" transform="translate(-309 174)">
                          <rect id="Rectángulo_468" data-name="Rectángulo 468" width="60" height="60" transform="translate(2389 6638)" />
                        </g>
                        <g id="Grupo_734" data-name="Grupo 734" transform="translate(1 7.672)">
                          <g id="Grupo_732" data-name="Grupo 732" transform="translate(2088 6812.184)">
                            <path id="Trazado_220" data-name="Trazado 220" d="M42,47h7.515l5.3,6.962L60.787,47h3.757l-8.067,9.172L65.87,68.66H58.576L52.83,61.145,46.2,68.66H42.442l8.62-9.835Zm4.42,2.21h2.1L61.56,66.45H59.571Z" transform="translate(-32.717 -36.686)" fill="#fff" />
                          </g>
                          <path id="Trazado_221" data-name="Trazado 221" d="M46.42,49.21h2.1L61.56,66.45H59.571Z" transform="translate(2055.283 6775.55)" />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <span>X (Twitter)</span>
                </a>

                <a href={shareLinks.facebook} target="_blank" rel="noreferrer" className="social-item facebook">
                  <div className="icon-box">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                      <g id="Grupo_736" data-name="Grupo 736" transform="translate(-2033 -6937)">
                        <g id="Grupo_733" data-name="Grupo 733" transform="translate(-356 299)">
                          <rect id="Rectángulo_468" data-name="Rectángulo 468" width="60" height="60" transform="translate(2389 6638)" fill="#3b5998" />
                        </g>
                        <path id="Trazado_223" data-name="Trazado 223" d="M25.731,45h5.458V30.007h4.095l.81-4.685h-4.9V21.928c0-1.094.708-2.243,1.719-2.243H35.7V15H32.279v.021c-5.345.194-6.443,3.29-6.539,6.541h-.01v3.76H23v4.685h2.731Z" transform="translate(2033.453 6937)" fill="#fff" />
                      </g>
                    </svg>
                  </div>
                  <span>Facebook</span>
                </a>
              </div>

              {/* Copiar Enlace */}
              <span className="section-label">Copiar enlace</span>
              <div className="copy-link-wrapper">
                <div className="url-text">
                  {currentUrl}
                </div>
                <button
                  onClick={copyToClipboard}
                  className={`copy-btn ${copied ? 'copied' : ''}`}
                >
                  {copied ? (
                    <><Check fontSize='16' /> Copiado</>
                  ) : (
                    <><ContentCopy fontSize='16' /> Copiar</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}